import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

export default function Header() {
  const { lang, toggleLanguage } = useLanguage();

  return (
    <motion.header 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
      className="fixed w-full top-0 z-50 px-6 md:px-12 py-8 bg-gradient-to-b from-brand-black/90 to-transparent backdrop-blur-[2px]"
      role="banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="hidden md:block w-24"></div>
        
        {/* H1: Primary Brand Identity for SEO */}
        <h1 className="font-serif text-2xl md:text-3xl tracking-ultra-wide text-brand-gold font-light absolute left-1/2 -translate-x-1/2">
          METANOIA
        </h1>

        <nav className="flex items-center gap-4 font-sans text-[10px] md:text-xs tracking-widest font-medium" aria-label="Language selector">
          <button 
            onClick={() => toggleLanguage('en')}
            className={`transition-colors duration-300 ${lang === 'en' ? 'text-brand-gold' : 'text-white/40 hover:text-white'}`}
            aria-pressed={lang === 'en'}
          >
            EN
          </button>
          <span className="text-white/20" aria-hidden="true">|</span>
          <button 
            onClick={() => toggleLanguage('es')}
            className={`transition-colors duration-300 ${lang === 'es' ? 'text-brand-gold' : 'text-white/40 hover:text-white'}`}
            aria-pressed={lang === 'es'}
          >
            ES
          </button>
        </nav>
      </div>
    </motion.header>
  );
}